import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    Automobile,
    CreateAutomobileInput,
    ModelAutomobileFilterInput,
    UpdateAutomobileInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class AutoMobileService {
    constructor() {}
    private amplifyClient = generateClient();

    async listAllAutomobiles(limit: number = 500): Promise<Automobile[]> {
        const automobiles: Automobile[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listAutomobiles,
                        variables: { limit, nextToken }
                    })
                ).data.listAutomobiles;
                automobiles.push(...((response?.items ?? []) as Automobile[]));
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);

            return automobiles;
        } catch (error) {
            console.error('Error finding automobile:', error);
            return [];
        }
    }

    async listAutomobiles(): Promise<Automobile[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listAutomobiles
                })
            ).data.listAutomobiles.items;
            if (data) return data as Automobile[];
        } catch (error) {
            console.error('Error finding automobile:', error);
            return null;
        }
    }

    async getAutosByCreated(id: string): Promise<Automobile[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getAutosByCreated,
                    variables: {
                        id
                    }
                })
            ).data.getAutosByCreated.items;
            if (data) return data as Automobile[];
        } catch (error) {
            console.error('Error automobile:', error);
            return null;
        }
    }

    async getAutosByClientId(
        clientId: string,
        filter: ModelAutomobileFilterInput = null
    ): Promise<Automobile[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getAutosByClientId,
                    variables: {
                        clientId,
                        filter
                    }
                })
            ).data.getAutosByClientId.items;
            if (data) return data as Automobile[];
        } catch (error) {
            console.error('Error automobile:', error);
            return null;
        }
    }

    async getAutomobile(id: string): Promise<Automobile> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getAutomobile,
                    variables: {
                        id
                    }
                })
            ).data.getAutomobile;
            if (data) return data as Automobile;
        } catch (error) {
            console.error('Error automobile:', error);
            return null;
        }
    }

    async createAutomobile(input: CreateAutomobileInput): Promise<Automobile> {
        try {
            const automobile = (
                await this.amplifyClient.graphql({
                    query: mutations.createAutomobile,
                    variables: {
                        input
                    }
                })
            ).data.createAutomobile;
            if (automobile) return automobile as Automobile;
        } catch (error) {
            console.error('Error creating automobile:', error);
            return null;
        }
    }

    async updateAutomobile(input: UpdateAutomobileInput): Promise<Automobile> {
        try {
            const automobile = (
                await this.amplifyClient.graphql({
                    query: mutations.updateAutomobile,
                    variables: {
                        input
                    }
                })
            ).data.updateAutomobile;
            if (automobile) return automobile as Automobile;
        } catch (error) {
            console.error('Error updating automobile', error);
            return null;
        }
    }
}
